'use strict';

import axios from 'axios';
import { showUserError, setChecked } from './_utils';

const api = window.llbPortal.apiUrls,

	hasPortalApi = 'llbPortal' in window && 'api' in window.llbPortal,

	getSiblingSwitches = (element) => {
		return element.parentElement.querySelectorAll('.switch-input').length > 1 ? element.parentElement.querySelectorAll('.switch-input') : undefined;
	},

	enableWatchList = (id, target) => {
		let link = api.subscriptionApi;

		axios.post(link, {
			id: id
		}).then((response) => {
			console.log(response.data.Success);
		}).catch((error) => {
			setChecked(target, false);
			showUserError(error);
			console.log(error);
		});
	},

	disableWatchList = (id, target) => {
		let link = `${api.subscriptionApi}/${id}`;

		axios.post(link).then((response) => {
			console.log(response.data.Success);
			let siblingSwitches = getSiblingSwitches(target);

			if (siblingSwitches) {
				setChecked(siblingSwitches[1], response.data.SubscriptionEnabled || false);
			}

		}).catch((error) => {
			setChecked(target, true);
			showUserError(error);
			console.log(error);
		});
	};

export const toggleSubscription = (id, event) => {
	if (event.currentTarget.checked) {
		enableWatchList(id, event.currentTarget);
	} else {
		disableWatchList(id, event.currentTarget);
	}
};

export const removeSubscription = (id, event) => {
	let link = `${api.subscriptionApi}/${id}`,
		line = event.currentTarget.parentNode.parentNode;

	axios.post(link).then((response) => {
		console.log(response.data.Success);
		line.parentNode.removeChild(line);

		if (document.getElementsByClassName('watchlist__item').length === 0 && document.querySelector('.no-rows.hidden')) {
			document.querySelector('.no-rows.hidden').classList.remove('hidden');
		}

	}).catch((error) => {
		showUserError(error);
		console.log(error);
	});
};
